import React, { Component } from 'react';
import * as d3 from "d3";
import _ from "underscore";
import { graphScroll } from "./graph-scroll/index";
import { lineChart } from "./components/line-chart";

import { textCrawler } from "./components/text-crawler";

import './App.css';

const blue= "#0F4B91";
const green="#799A3D";
const purple="#863375";

const annotations = [
        { 
          key: 0,
          annotations: [
            {
              "x": new Date("01/01/1925"),
              "y": 45,
              "flip": false,
              "text": "1925 Tuberculosis Vaccine"
            },
            {
              "x": new Date("01/01/1953"),
              "y": 9.1,
              "flip": false,
              "text": "1953 Polio Vaccine"
            },
            {
              "x": new Date("01/01/1971"),
              "y": 3.7,
              "flip": false,
              "text": "1971 MRI & CT Scans"
            }
          ]
        },
        { 
          key: 1,
          annotations: [
            {
              "x": new Date("01/01/1908"),
              "y": 0.342,
              "flip": false,
              "text": "1908 Model-T Ford"
            }
          ]
        },
        { 
          key: 2,
          annotations: [
            {
              "x": new Date("01/01/1700"),
              "y": 0,
              "flip": false,
              "text": ""
            }
          ]
        },
        { 
          key: 3,
          annotations: [
            {
              "x": new Date("01/01/1965"),
              "y": 1641,
              "flip": false,
              "text": "1965 Medicare & Medicaid signed"
            },
            {
              "x": new Date("01/01/2010"),
              "y": 9024,
              "flip": true,
              "text": "2010 Affordable Care Act"
            }
          ]
        },
        { 
          key: 4,
          annotations: [
            {
              "x": new Date("01/01/1700"),
              "y": 90,
              "flip": false,
              "text": ""
            }
          ]
        },
        { 
          key: 5,
          annotations: [
            {
              "x": new Date("01/01/1700"),
              "y": 90,
              "flip": false,
              "text": ""
            }
          ]
        },
        { 
          key: 6,
          annotations: [
            {
              "x": new Date("01/01/1905"),
              "y": 9.46,
              "flip": false,
              "text": "1905 First dial telephone",
            },
            {
              "x": new Date("01/01/1964"),
              "y": 82.1,
              "flip": true,
              "text": "1964 First commercial fax machine"
            },
            {
              "x": new Date("01/01/1984"),
              "y": 92.8,
              "flip": true,
              "text": "1984 First commercial cell phone"
            },
            {
              "x": new Date("01/01/1984"),
              "y": 8.2,
              "flip": true,
              "text": "1984 First Macintosh computer"
            }
          ]
        },
        { 
          key: 7,
          annotations: [
            {
              "x": new Date("01/01/2006"),
              "y": 29.2,
              "flip": true,
              "text": "2006 Stark EHR Exception"
            }
          ]
        },
        { 
          key: 8,
          annotations: [
            {
              "x": new Date(0, 1, 1),
              "y": 90,
              "flip": false,
              "text": ""
            }
          ]
        },
        { 
          key: 9,
          annotations: [
            {
              "x": new Date(0, 1, 1),
              "y": 90,
              "flip": false,
              "text": ""
            }
          ]
        },
        { 
          key: 10,
          annotations: [
            {
              "x": new Date("01/01/1982"),
              "y": 260,
              "flip": false,
              "text": "1982 Prospective Payment System (DRGs)"
            },
            {
              "x": new Date("01/01/1996"),
              "y": 2114,
              "flip": false,
              "text": "1996 HIPAA"
            },
            {
              "x": new Date("01/01/2009"),
              "y": 3076,
              "flip": false,
              "text": "2009 HITECH Act"
            }
          ]
        },
        { 
          key: 11,
          annotations: [
            {
              "x": new Date("01/01/0"),
              "y": -100,
              "flip": false,
              "text": ""
            }
          ]
        },
        { 
          key: 12,
          annotations: [
            {
              "x": new Date("01/01/0"),
              "y": -100,
              "flip": false,
              "text": ""
            }
          ]
        }
];

const mainData = [
        {
          key: 0,
          chapter: 1,
          data: "house-calls",
          chapterHeader: "The Changing Patient-Provider Experience",
          chartHeader: "Average % of Physician House-Calls",
          narrative: "The physician house call, once the common standard for medical care, has become a thing of the past as advances in treatment and technology drove care into offices and facilities...",
          greentip: "House Calls"
        },
        {
          key: 1,
          chapter: 1,
          data: "cars",
          chapterHeader: "The Changing Patient-Provider Experience",
          chartHeader: "Automotive Vehicles as % of U.S. Population",
          narrative: "Increased access to passenger cars, and highway systems, enabled patients to travel farther from home to receive quality medical treatment.",
          greentip: "Automobiles"
        },
        {
          key: 2,
          chapter: 1,
          data: "avg-visits",
          chapterHeader: "The Changing Patient-Provider Experience",
          chartHeader: "Number of Office Visits per Patient",
          narrative: "This contributed to increased utilization as patients returned for more frequent and varied care." ,
          greentip: "Office Visits"
        },
        {
          key: 3,
          chapter: 1,
          data: "expenditures",
          chapterHeader: "The Changing Patient-Provider Experience",
          chartHeader: "Average U.S. Health Expenditure per Person in 2015 Dollars",
          narrative: "With access to more frequent care and more advanced procedures, subsidized by government and commercial programs, the cost of care has steadily increased.",
          greentip: "Health Care Expenditure"
        },
        {
          key: 4,
          chapter: 1,
          data: "life-expectancy",
          chapterHeader: "The Changing Patient-Provider Experience",
          chartHeader: "Average Life Expectancy",
          narrative: "But with that has come better care for more patients – and a more than 30-year improvement in life expectancy.",
          greentip: "Life Expectancy"
        },
        {
          key: 5,
          chapter: 1,
          data: "patient-time",
          chapterHeader: "The Changing Patient-Provider Experience",
          chartHeader: "Average Time Spent With Patients",
          narrative: "The lengthy and intimate patient visit of the past is long gone. Today, doctors spend on average a mere 13.4<span style='font-family: FuturaMedium;'>¹</span>  minutes with their patients.",
          greentip: "Time with Patients"
        },
        {
          key: 6,
          chapter: 2,
          data: "",
          chapterHeader: "Technology and Physician Discontent",
          chartHeader: "Technology Adoption Rates",
          narrative: "Compared to the adoption paths of other technological developments, electronic health records have been thrust upon physicians at a fast and furious pace. It should be no surprise that we’re still figuring out how to make them work meaningfully for us.",
          greentip: ""
        },
        {
          key: 7,
          chapter: 2,
          data: "",
          chapterHeader: "Technology and Physician Discontent",
          chartHeader: "Technology Adoption Rates",
          narrative: "Backed by government mandates and incentives, EHR adoption among physicians has reached over 80%<span style='font-family: FuturaMedium;'>²</span> in just 15 years.",
          greentip: ""
        },
        {
          key: 8,
          chapter: 2,
          data: "",
          chapterHeader: "Technology and Physician Discontent",
          chartHeader: "Physician Satisfaction",
          narrative: "Unfortunately, over those same 15 years, we’ve seen physician job satisfaction steadily decline. Coincidence?",
          greentip: ""
        },
        {
          key: 9,
          chapter: 3,
          data: "physician-growth",
          chapterHeader: "Provider’s Administrative Burdens",
          chartHeader: "Growth in Number of Physicians since 1970",
          narrative: "The number of physicians in the U.S. has grown 150%<span style='font-family: FuturaMedium;'>³</span> since 1970, roughly keeping pace with population growth.",
          greentip: "Physician Growth"
        },
        {
          key: 10,
          chapter: 3,
          data: "administrative-roles",
          chapterHeader: "Provider’s Administrative Burdens",
          chartHeader: "Growth in Administrative Roles since 1970",
          narrative: "But that growth pales in comparison to the 3200%⁴ increase in health care administrators over the same period.",
          greentip: "Admin Growth"
        },
        {
          key: 11,
          chapter: 3,
          data: "admin-work",
          chapterHeader: "Provider’s Administrative Burdens",
          chartHeader: "Average MD Time Spent on Administrative Work",
          narrative: "Even with the support of this growing army of administrators... the administrative burden on physicians has continued to grow and grow.",
          greentip: "Admin Time"
        },
        {
          key: 12,
          chapter: 3,
          data: "",
          chapterHeader: "",
          chartHeader: "",
          narrative: "",
          greentip: ""
        }
    ];

var chartWidth;
var chartHeight;
var width;
var height;
var r;
var svg;
var graphic;

var currIndex=0;
var currentChapter;
var mobile = window.innerWidth < 768 ? true:false;

var keys;
var voronoiData;

var currentObject;
var dataIndex;
var currentData;
var currentName;

const progress = {};

function getChartSize() {
  var w,h
  if(window.innerWidth>980){
    // w = 1*parseInt(graphic.style('width'), 10)
    w = .85*parseInt(graphic.style('width'), 10)
    h = .7*parseInt(w*5/9, 10)
  }else if(window.innerWidth<980){
    // w = .95*parseInt(graphic.style('width'), 10)
    w = .95*parseInt(graphic.style('width'), 10)
    h = .7*parseInt(w*4/9, 10)
  }else{
    w = 1*parseInt(graphic.style('width'), 10)
    h = .7*parseInt(w*5/9, 10)
  }
  console.log(graphic.style('width'))
  return  [w,h]
};

function revealLegend() {
  d3.select(".legend-container").transition().duration(1000).style("opacity", "1");
}

function hideLegend() {
  d3.select(".legend-container").transition().duration(1000).style("opacity", "0");
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      keys: mainData,
      foo: "bar",
      currentIndex: 0,
      previousChapter: 1,
      dataDictionary: [],
    };

    this.instantiateChart = this.instantiateChart.bind(this); //necessary to make `this` work in the callback
  }  

  componentDidMount(){
    const self=this;
    keys = self.state.keys;

    const formatDate = d3.timeParse("%Y");
    const dataNames = [];
    const dataDictionary = {};

    keys.forEach(function(x) {
      dataNames.push(x.data);
    });

    function type(d) {
      return {
        x:formatDate(d.x),
        y:+d.y,
        tech: d.tech
      }
    }

    function ajax(url) {
        var promise = new Promise(
            function resolver(resolve, reject) {
                d3.csv("data/" + url + ".csv", type, function(d) {
                    // console.warn(url);
                    resolve(d);
                });
            })
        return promise;
    }

    function sequence(array, callback) {
        return array.reduce(function chain(promise, item) {
            return promise.then(function() {
                return callback(item);
            });
        }, Promise.resolve());
    };

    function getInfo(url) {
        return ajax(url);
    };

    sequence(dataNames, function(sku) {
        return getInfo(sku).then(function(info) {
            const obj = {};
            obj['data'] = info;
            obj['name'] = sku;
            dataDictionary[sku] = obj;
        });
    }).catch(function(reason) {
        console.error(reason);
    }).then(function(info) {
        self.setState({
          dataDictionary
        })
    });

    function addData(data) {
      voronoiData = data;
    }

    function loadVoronoiData(url) {
      return new Promise((resolve, reject) => {
        d3.csv("data/" + url + ".csv", type, function(d) {
            resolve(d);
        });

      });
    };

    Promise.all([
      loadVoronoiData("ehr"),
      loadVoronoiData("household-computers"),
      loadVoronoiData("household-phones"),
      loadVoronoiData("internet-usage"),
      loadVoronoiData("physician-satisfaction")
    ]).then((datum) => {
      addData(datum)
    });

    d3.select("#down-button")
        .on("mouseover", function() {
          console.warn()
          d3.select(this).select("#down-button-svg-container").classed("bounce", true).classed("animated", true);
        })
        .on("mouseout", function() {
          d3.select(this).select("#down-button-svg-container").classed("bounce", false).classed("animated", false);
        });

    svg = d3.select('#chart')
    .append('svg')
      .attr("width", width)
      .attr("height", height);

    graphic = d3.select("#graphic");


    mobile = window.innerWidth < 768 ? true:false;

  };

  sayBoo() {
    console.log('boo');
  };

  instantiateChart () {
    const self = this;
    mobile = window.innerWidth < 768 ? true:false;

    chartWidth = getChartSize()[0];
    chartHeight = getChartSize()[1];

    width = chartWidth,
    height = chartHeight,
    r = 40;

    self.drawChart();

  };

  drawChart() {
    const self = this;

        function showEndnotes() {

          d3.select("#headline-card").remove();

          d3.select("#full-header").transition().duration(500).style("opacity", 0);
          d3.select("#inner-content").transition().duration(500).style("opacity", 0);
          window.setTimeout(function() {
            d3.select("#inner-content").style("display", "none").style("visibility", "invisible");
            const cardContainer = d3.select("#card-container");
            const headlineCard = cardContainer.append("div").attr("id", "headline-card")
            const cardBgContainer = headlineCard.append("div").attr("class", "card__bg__image");
            if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
              d3.select("#full-header").remove();

              cardBgContainer.append("img").attr("id", "card").attr("src", "images/hero.jpg")
                // .attr("class", "blurry")
                .classed("blurry",true)
                .style("opacity", 1);

            } else {
              cardBgContainer.append("img").attr("id", "card").attr("src", "images/hero.jpg")
                .attr("class", "blurry")
                .style("opacity", 0)
                .transition().duration(1000)
                .style("opacity", 1);
            }

            const cardTextContainer = cardBgContainer.append("div").attr("id", "cover-header");
          // },0);
              
            const cardText = d3.select(".card__bg__image");

            const flexContainer = cardText.append("div").attr("class", "flex-container")
              .style("display", "flex")
              .style("flex-direction", "column")
              .style("align-items", "center")
              .style("justify-content", "center")
              .style("top", 0)
              .style("position", "absolute")
              .style("width", "100%")
              .style("height", "100%");

            flexContainer.append("div").attr("class", "closing-big-text").append("div").attr("class", "white-text text-center").text("Through the years, the practice of medicine has evolved and adapted as technology has played a bigger and bigger role in the delivery and experience of care.");

            d3.select(".closing-big-text").append("div").attr("class", "closing-green-text text-center").text("But is it all progress?");
            d3.select(".closing-big-text").append("div").attr("class", "white-text text-center").text("Let us know what you think by commenting and sharing on your social handles");
            d3.select(".closing-big-text").append("div").attr("class", "social-media-icons");
            const replayButton = d3.select(".closing-big-text")
              .append("div")
              .attr("class", "closing-replay");

            replayButton.append("div").attr("class", "closing-replay-div")
              .append("svg")
              .attr("viewBox", "0 0 39.16 44.03")
              .append("path")
              .attr("d", "M30.88,8.66A20.28,20.28,0,0,0,35.78.49,32.71,32.71,0,0,1,20,7.36c4.61,3.55,7.56,8.83,9.84,14.12a23.52,23.52,0,0,0,.34-8.33,15.58,15.58,0,1,1-23.1,3.08L3.77,14A19.58,19.58,0,1,0,30.88,8.66Z")
              .style("fill", "white");

            replayButton.append("div").attr("class", "white-text").style("display", "inline-block").style("text-align", "center").text("Replay");

            replayButton.on("click", function() {
              if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                window.location.reload(false);
              } else {
                redrawHeadlineCard();
              }
            });

            const card = d3.select(".card__bg__image");

            const smIcons = flexContainer.append("div").attr("class", "social-media-icons")

              smIcons.append("div").attr("class", "sm-icon")
                            .append("a").attr("href", "http://www.facebook.com/sharer/sharer.php?m2w&amp;s=100&amp;u=http://insight.athenahealth.com/infographic-evolution-medical-practice&amp;display=popup&amp;ref=plugin&amp;src=like&amp;app_id=113869198637480")
              .attr("target", "_blank")
              .append("svg")
                .style("width", "56px")
                .style("height", "56px")
               .append("path")
                .attr("d", "M28,0.45A27.55,27.55,0,1,0,55.55,28,27.55,27.55,0,0,0,28,.45Zm7.68,16.77c-0.84.13-2.34,0-3.29,0s-1.76.44-1.75,1.57a17,17,0,0,0-.06,3.53c0.27,0.1,4.42,0,5.08,0l0,0.39L35.11,28l-4.5,0V44.52H24.44V28H20.32V22.37h4.11c0-1.29,0-2.86,0-4.11a8.1,8.1,0,0,1,1.37-4.78c2.14-2.57,6.88-1.9,9.87-1.9v5.66Z")
                .attr("transform","translate(-0.45 -0.45)")
                .attr("fill","#b9c932");

            smIcons.append("div").attr("class", "sm-icon")
              .append("a").attr("href", "http://twitter.com/intent/tweet?status=Housecalls are a thing of the past. But so is polio. Explore how medicine has changed in this interactive.+http://tiny.cc/medical-evolution")
              .attr("target", "_blank")
              .append("svg")
                .style("width", "56px")
                .style("height", "56px")
               .append("path")
                .attr("d", "M28,0.45A27.55,27.55,0,1,0,55.55,28,27.55,27.55,0,0,0,28,.45ZM43.66,19.11A9.49,9.49,0,0,1,41.26,21l0.06,0.57C42.12,36.08,26.1,45.9,12.66,39.28,12.06,39,11.8,39,11.78,38.64a18.58,18.58,0,0,0,5.68-.72A10.51,10.51,0,0,0,19.69,37a8.88,8.88,0,0,0,1.85-1.32l-2.07-.53a10,10,0,0,1-2.53-1.4c-0.52-.44-1.6-1.46-1.6-2.2A4.35,4.35,0,0,1,18,30.78c-1.57-.67-2.62-0.94-3.75-2.34a6.84,6.84,0,0,1-1.1-1.94,5.42,5.42,0,0,1-.36-1.82c0.27-.78.71,0.27,3,0.27a14.62,14.62,0,0,1-1.16-1.06,12.62,12.62,0,0,1-1-1.26,6.25,6.25,0,0,1-.78-5.32,1.1,1.1,0,0,1,.87-1.1l1.38,1.22c3,2.78,8.51,5.56,12.51,5.56V21.84a7.25,7.25,0,0,1,3.76-6.57c4.36-2,7.62,1.27,7.9,1.25l2.38-.41a5.44,5.44,0,0,0,1-.4c0.19-.1.87-0.5,0.87,0l-1.1,1.76c-0.18.25-1.44,1.2-1.5,1.29a24.85,24.85,0,0,0,2.61-.63C44.7,17.76,44.14,18.45,43.66,19.11Z")
                .attr("transform","translate(-0.45 -0.45)") 
                .attr("fill","#b9c932");

            smIcons.append("div").attr("class", "sm-icon")
              .append("a").attr("href", "http://www.linkedin.com/shareArticle?mini=true&amp;url=http://insight.athenahealth.com/infographic-evolution-medical-practice&amp;title=The Evolution of Medical Practice: Housecalls are a thing of the past. But so is polio. Explore how medicine has changed in this interactive.&amp;source=http://insight.athenahealth.com/infographic-evolution-medical-practice")
              .attr("target", "_blank")
              .append("svg")
                .style("width", "56px")
                .style("height", "56px")
               .append("path")
                .attr("d", "M28,0.45A27.55,27.55,0,1,0,55.55,28,27.55,27.55,0,0,0,28,.45ZM14.85,41.36V23.5l5.63-.08,0,18Zm3.83-20.43c-4.44,1.28-6-5.19-1.85-6.23C21.16,13.61,22.39,19.86,18.68,20.93ZM41.59,33.29v8.13H35.95V33.12c0-2.71-.32-5.21-3.19-5.19s-3.1,2.63-3.09,5.19v8.3H24v-18l5.46,0v2.31a1,1,0,0,0,.33-0.26l0.78-.79A6.4,6.4,0,0,1,35.19,23C42,23.1,41.59,29.33,41.59,33.29Z")
                .attr("transform","translate(-0.45 -0.45)")
                .attr("fill","#b9c932");

            flexContainer.append("div")
              .attr("class", "horizontal-line")
              .style("background-color", "#FFF")
              .style("width", "80%")
              .style("height", "1px")
              .style("margin", "3% 0");
              // .style("margin-left", "17%")
              // .style("margin-right", "17%");


            d3.select(".card__bg__image").append("div").style("font-size", "27px")
              .html("<div class='white-text text-center' style='font-size: 27px;'>Sources</div>");

            const smallerText = flexContainer.append("div").attr("class","white-text footnotes futura-light")
              // .style("position","absolute")
              // .style("top", "60%")
              .style("width", "100%")
              .style("display", "flex")
              .style("align-items", "center")
              .style("justify-content", "center")
              .style("margin-top", "1%");
              

            smallerText.append("div").attr("class", "left-column footnotes")
              .style("font-size", "10px")
              .style("float", "left")
              // .style("margin-left", "10%")
              .style("width", "40%")
              .html('<ol><li><div class="closing-bold-footnote">Average % of Physician House-Calls:</div><div class="closing-source-footnote">Source: American Family Physician.</div></li><li><div class="closing-bold-footnote">Automotive vehicles as % of U.S. Population:</div><div class="closing-source-footnote">Sources: LA Times; Google Public Data; United States Census Bureau; U.S. Department of Transportation Federal Highway Administration.</div></li><li><div class="closing-bold-footnote">Average Annual Office Visits:</div><div class="closing-source-footnote">Source: United States Census Bureau; Commonwealth Fund.</div></li><li><div class="closing-bold-footnote">Average U.S. Health Expenditure per Person in 2015 Dollars:</div><div class="closing-source-footnote">Source: United States Census Bureau; National Health Expenditure Accounts from the Centers for Medicare and Medicaid Services.</div></li><li><div class="closing-bold-footnote">Average Life Expectancy:</div><div class="closing-source-footnote">Source: Our World in Data</div></li></ol>');
          

            smallerText.append("div").attr("class", "right-column footnotes")
              // .style("margin-left", "50%")
              .style("width", "40%")
              .style("font-size", "10px")
              .html('<ol start="6"><li><div class="closing-bold-footnote">Average Time Spent With Patients:</div><div class="closing-source-footnote">Source: Historic research; athenaResearch.</div></li><li><div class="closing-bold-footnote">Technology Adoption Rates:</div><div class="closing-source-footnote">Sources: United States Census Bureau; Sears Modern Homes; World Bank; Health IT.</div></li><li><div class="closing-bold-footnote">Physician Satisfaction:</div><div class="closing-source-footnote">Source: historic research; Robert Wood Johnson Surveys; Women Physicians Health Surveys; Community Tracking Surveys; Physician Worklife Surveys.</div></li><li><div class="closing-bold-footnote">Growth in Number of Physicians and Administrative Roles since 1970</div><div class="closing-source-footnote">Source: Bureau of Labor Statistics; NCHS and Himmelstein/Woolhandler analysisof CPS.</div></li><li><div class="closing-bold-footnote">Average MD Time Spent on Administrative Work:</div><div class="closing-source-footnote">Source: Physicians for a National Health Program; historic research.</div></li></ol>');
          }, 0);

        };

      /* END OF `showEndnotes()` */
      /*                  */
      /*                  */

    function redrawHeadlineCard() {
      //"on", startOver

      // const cardContainer = d3.select("#card-container").append("div").attr("id", "headline-card");
      // const imgContainer = cardContainer.append("div").attr("class", "card__bg__image");
      // imgContainer.append("img").attr("src", "images/hero.jpg");
      // const coverHeader = imgContainer.append("div").attr("id", "cover-header");
      d3.select('.horizontal-line').style("opacity", 0);
      d3.select('.closing-big-text').style("opacity", 1).transition().duration(200).style("opacity", 0);
      d3.select('.closing-big-text').style("opacity", 1).transition().duration(200).style("opacity", 0);
      d3.selectAll('.social-media-icons').style("opacity", 1).transition().duration(200).style("opacity", 0);
      d3.selectAll('.footnotes').style("opacity", 1).transition().duration(200).style("opacity", 0);

      d3.select("#headline-card").select("img").classed("blurry", false).classed("unblur-animation", true);

      const imgContainer = d3.select(".card__bg__image");

      const cardContainer = d3.select("#card-container");
      const coverHeader = d3.select("#headline-card").append("div").attr("id", "cover-header");
      const header = coverHeader.append("h1");
      header.html("<span>The</span><br /><span>Evolution</span><br /><span>of Medical</span><br /><span>Practice</span><br />");
      coverHeader.append("h2").text("1890 to Today");

      const downButton = imgContainer.append("div").attr("id", "down-button")
      downButton.append("img").attr("id", "click-proceed").attr("src", "images/click-proceed.png");

      downButton.append("img").attr("id", "swoopy-line").attr("src", "images/swoopy-line.png");

      const svg = downButton.append("svg").attr("id", "down-button-svg-container").attr("viewBox", "0 0 78 43");      
      svg.append("path").attr("id", "swoop")
        .attr("d", "M39,43L0.88,5.09A3,3,0,0,1,.88.87a3,3,0,0,1,4.24,0L39,34.56,72.88,0.87a3,3,0,0,1,4.24,0,3,3,0,0,1,0,4.22Z")
        .attr("transform", "translate(0)")
        .attr("fill", "#f1f2f2");

      d3.select("#down-button")
        .on("mouseover", function() {
          console.warn()
          d3.select(this).select("#down-button-svg-container").classed("bounce", true).classed("animated", true);
        })
        .on("mouseout", function() {
          d3.select(this).select("#down-button-svg-container").classed("bounce", false).classed("animated", false);
        })
        .on("click", startOver);
    } 


    function startOver() {
      currIndex = 0;
      d3.select("#headline-card").style("opacity", 0);
      d3.select("#headline-card").remove();

      d3.select("#full-header").transition().duration(1000).style("opacity", 1);
      d3.select("#inner-content").style("display", "block").style("visibility", "visible");
      d3.select("#inner-content").transition().duration(1000).style("opacity", 1);

          if (window.innerWidth < 768) {
            mobile = true;
          } else {
            mobile = false;
          }

          chartWidth = getChartSize()[0]
          chartHeight = getChartSize()[1];

          if (mobile == false) {
              d3.select('.foot').transition().duration(1000).style("opacity", 1);
              d3.select('.foot-overlay').transition().duration(1000).style("opacity", 1).style("display", "block").style("visibility", "visible");
              d3.select('#full-header').style("opacity", 1);
              d3.select('#mobile').style("opacity", 0);
              d3.select("defs").selectAll("clipPath").remove();
              window.setTimeout(function() {
                window.scrollTo(0,0);
                gs.scrollTo(0);
                chart.resize(chartWidth,chartHeight);
                currIndex = 0;
                console.warn(self.state.dataDictionary['house-calls'].data, 0, 1, "house-calls")
                chart.data(self.state.dataDictionary['house-calls'].data, 0, 1, "house-calls");
                chart.appendGreenTip("house-calls");
              }, 0);
          } else {
            d3.select('.foot').style("opacity", 0);
            d3.select('.foot-overlay').style("opacity", 0);
            d3.select('#full-header').style("opacity", 0);
          }
    }; /// end of `startOver()`


    d3.select("#headline-card").style("opacity", 0);
    d3.select("#full-header").style("opacity", 1);
    d3.select("#headline-card").remove();

    window.setTimeout(function() { 
      d3.selectAll("polyline").transition().duration(1000).style("opacity", 1);
      d3.selectAll("circle").transition().duration(1000).style("opacity", 1);
    }, 0);

    //sets pageYOffset to be `0` automatically on page load
    window.onbeforeunload = function(){
      window.scrollTo(0,0);
    }

    const docheight = d3.select("body").node().getBoundingClientRect().height;
    const winheight = window.innerHeight;

    progress.el = d3.select('#bg-progress');
    progress.scale = d3.scaleLinear().domain([0,12]).range([0, 100]);
    
    window.onscroll = function() {
      let currProgress;
      let bgColor;
      if (currIndex == undefined) {
        currProgress == 0;
      } else if (currIndex == 0) {
        currProgress = 0;
      } else if (currIndex !== 12) {
        currProgress = currIndex;
      } else if (currIndex == 12){
        currProgress = 11;
      }

      if (currentChapter==1) {
        bgColor = purple;
      } else if (currentChapter==2) {
        bgColor = blue;
      } else if (currentChapter==3) {
        bgColor = green;
      }
      progress.el.style("width", progress.scale(currProgress)+"%").style("background-color", bgColor);
    };

    //stick header to top of page
    var fixedHeader = null
    d3.select(window).on('scroll.sticky', function(){
      var fixedHeader1 = pageYOffset >= 0
      if (fixedHeader != fixedHeader1){
        fixedHeader = fixedHeader1

        d3.select('#full-header').classed('stuck', fixedHeader)
        d3.select('#full-header-space').classed('stuck', fixedHeader)
      }
    });

// Append text sections
    const sections = graphic.select("#sections").selectAll(".section")
      .data(keys).enter()
      .append("div")
      .text(function(d) { return d.narrative; })

      // if(this.state.currentIndex==0) {
      //   intro();
      // } else {
      //   // main();
      // }

     /* APPEND MOBILE STUFF */
    // var mGraphic = d3.select("#mobile")
    var mSections = d3.select("#mobile").selectAll("div")
      .data(keys).enter()
      .append("div")
      .attr("class", "mob-section");
    
    mSections.append('div').html(function(d) { return d.chapterHeader});
    mSections.append('div').html(function(d) { return d.chartHeader});
    mSections.append('div').append("img").attr("src", function(d,i) { return i <= 11 ? "images/"+i+".png" : "" })
      .style("max-width", "100%")
      .style("height", "auto");
    mSections.append('div').html(function(d) { return d.narrative});

    d3.select("#mobile").append('div').attr("id", "mob-endnote")
      .style("position", "relative")
      .style("overflow", "hidden")
      .style("height", "1200px")
      .style("width", "100%");


    d3.select("#mob-endnote").append("div").attr("class", "card__bg__image");
    d3.select("#mob-endnote").select("div").append("img")
      .attr("id", "card")
      .attr("src", "images/hero.jpg")
      .attr("class", "blurry");

    d3.select("#mob-endnote").append("div")
      .attr("class", "horizontal-line")
      .style("background-color", "#FFF")
      .style("width", "67%")
      .style("height", "1px")
      .style("margin-left", "17%")
      .style("margin-right", "17%");

    d3.select("#mob-endnote").append("div")
      .html('<div class="closing-big-text"><div class="white-text text-center">Through the years, the practice of medicine has evolved and adapted as technology has played a bigger and bigger role in the delivery and experience of care.</div><div class="closing-green-text text-center">But is it all progress?</div><div class="white-text text-center">Let us know what you think by commenting and sharing on your social handles</div><div class="social-media-icons"></div><div class="closing-replay"></div></div>');

    d3.select("#mob-endnote").append("div")
      .html('<div class="social-media-icons"><div class="sm-icon"><a href="http://www.facebook.com/sharer/sharer.php?m2w&amp;amp;s=100&amp;amp;u=http://insight.athenahealth.com/infographic-evolution-medical-practice&amp;amp;display=popup&amp;amp;ref=plugin&amp;amp;src=like&amp;amp;app_id=113869198637480" target="_blank"><svg><path d="M28,0.45A27.55,27.55,0,1,0,55.55,28,27.55,27.55,0,0,0,28,.45Zm7.68,16.77c-0.84.13-2.34,0-3.29,0s-1.76.44-1.75,1.57a17,17,0,0,0-.06,3.53c0.27,0.1,4.42,0,5.08,0l0,0.39L35.11,28l-4.5,0V44.52H24.44V28H20.32V22.37h4.11c0-1.29,0-2.86,0-4.11a8.1,8.1,0,0,1,1.37-4.78c2.14-2.57,6.88-1.9,9.87-1.9v5.66Z" transform="translate(-0.45 -0.45)" fill="#b9c932"></path></svg></a></div><div class="sm-icon"><a href="http://twitter.com/intent/tweet?status=Housecalls are a thing of the past. But so is polio. Explore how medicine has changed in this interactive.+http://tiny.cc/medical-evolution" target="_blank"><svg><path d="M28,0.45A27.55,27.55,0,1,0,55.55,28,27.55,27.55,0,0,0,28,.45ZM43.66,19.11A9.49,9.49,0,0,1,41.26,21l0.06,0.57C42.12,36.08,26.1,45.9,12.66,39.28,12.06,39,11.8,39,11.78,38.64a18.58,18.58,0,0,0,5.68-.72A10.51,10.51,0,0,0,19.69,37a8.88,8.88,0,0,0,1.85-1.32l-2.07-.53a10,10,0,0,1-2.53-1.4c-0.52-.44-1.6-1.46-1.6-2.2A4.35,4.35,0,0,1,18,30.78c-1.57-.67-2.62-0.94-3.75-2.34a6.84,6.84,0,0,1-1.1-1.94,5.42,5.42,0,0,1-.36-1.82c0.27-.78.71,0.27,3,0.27a14.62,14.62,0,0,1-1.16-1.06,12.62,12.62,0,0,1-1-1.26,6.25,6.25,0,0,1-.78-5.32,1.1,1.1,0,0,1,.87-1.1l1.38,1.22c3,2.78,8.51,5.56,12.51,5.56V21.84a7.25,7.25,0,0,1,3.76-6.57c4.36-2,7.62,1.27,7.9,1.25l2.38-.41a5.44,5.44,0,0,0,1-.4c0.19-.1.87-0.5,0.87,0l-1.1,1.76c-0.18.25-1.44,1.2-1.5,1.29a24.85,24.85,0,0,0,2.61-.63C44.7,17.76,44.14,18.45,43.66,19.11Z" transform="translate(-0.45 -0.45)" fill="#b9c932"></path></svg></a></div><div class="sm-icon"><a href="http://www.linkedin.com/shareArticle?mini=true&amp;amp;url=http://insight.athenahealth.com/infographic-evolution-medical-practice&amp;amp;title=The Evolution of Medical Practice: Housecalls are a thing of the past. But so is polio. Explore how medicine has changed in this interactive.&amp;amp;source=http://insight.athenahealth.com/infographic-evolution-medical-practice" target="_blank"><svg><path d="M28,0.45A27.55,27.55,0,1,0,55.55,28,27.55,27.55,0,0,0,28,.45ZM14.85,41.36V23.5l5.63-.08,0,18Zm3.83-20.43c-4.44,1.28-6-5.19-1.85-6.23C21.16,13.61,22.39,19.86,18.68,20.93ZM41.59,33.29v8.13H35.95V33.12c0-2.71-.32-5.21-3.19-5.19s-3.1,2.63-3.09,5.19v8.3H24v-18l5.46,0v2.31a1,1,0,0,0,.33-0.26l0.78-.79A6.4,6.4,0,0,1,35.19,23C42,23.1,41.59,29.33,41.59,33.29Z" transform="translate(-0.45 -0.45)" fill="#b9c932"></path></svg></a></div></div>');

    d3.select("#mob-endnote").append("div")
      .style("position", "absolute")
      .style("top", "50%")
      .style("color", "white")
      .html('<ol>Sources: <li>Average % of Physician House-Calls:<br />Source: American Family Physician.</li><li>Automotive vehicles as % of U.S. Population:<br />Sources: LA Times; Google Public Data; United States Census Bureau; U.S. Department of Transportation Federal Highway Administration.</li><li>Average Annual Office Visits:<br />Source: United States Census Bureau; Commonwealth Fund.</li><li>Average U.S. Health Expenditure per Person in 2015 Dollars:<br />Source: United States Census Bureau; National Health Expenditure Accounts from the Centers for Medicare and Medicaid Services.</li><li>Average Life Expectancy:<br />Source: Our World in Data.</li><li>Average Time Spent With Patients:<br />Source: Historic research; athenaResearch.</li><li>Technology Adoption Rates:<br />Sources: United States Census Bureau; Sears Modern Homes; World Bank; Health IT.</li><li>Physician Satisfaction:<br />Source: historic research; Robert Wood Johnson Surveys; Women Physicians Health Surveys; Community Tracking Surveys; Physician Worklife Surveys.</li><li>Growth in Number of Physicians since 1970 /Growth in Administrative Roles since 1970:<br />Source: Bureau of Labor Statistics; NCHS and Himmelstein/Woolhandler analysisof CPS.</li><li>Average MD Time Spent on Administrative Work:<br />Source: Physicians for a National Health Program; historic research.</li></ol>');

  /* END OF MOBILE SECTION */


    const dataKeys = mainData.map(function(x, i) {
      const obj = {};
      obj['index'] = i;
      obj['name']= x.data;
      return obj;
    });

    const namesArray = mainData.map(function(x) {
      return x.data;
    });

    const chart = new lineChart('#chart','force-chart', [], chartWidth, chartHeight, dataKeys, mainData, annotations);
    chart.draw('#chart', 'force-chart');

    const textCrawl = new textCrawler("#foot", mainData);
    textCrawl.init();

    const gs = graphScroll()
      .container(d3.select('#graphic'))
      .graph(d3.selectAll('#chart'))
      .sections(d3.selectAll('#sections > div'))
      .on('active', function(i) {
          if (mobile == false) {
            d3.select('.foot').transition().duration(1000).style("opacity", 1);
            d3.select('.foot-overlay').transition().duration(1000).style("opacity", 1).style("display", "block").style("visibility", "visible");
          } else {
            d3.select('.foot').style("opacity", 0).style("visibility", "invisible").style("display", "none");
            d3.select('.foot-overlay').style("opacity", 0).style("visibility", "invisible").style("display", "none");
            d3.select('#full-header').style("opacity", 0).style("visibility", "invisible").style("display", "none");
            d3.select('#mobile').style("opacity", 1);
          }
          console.log(i + 'th section active');

          currIndex = i;
          currentObject = keys[i];

          dataIndex = currentObject.data;
          currentData = self.state.dataDictionary[dataIndex].data;
          currentName = self.state.dataDictionary[dataIndex].name;
          currentChapter = currentObject.chapter;

          const previousName = namesArray[i+1];

          textCrawl.move(i);
          textCrawl.data(currentChapter, i);

          //insert header text here
          d3.select("#header-text").text(keys[i].chapterHeader);
          d3.select("#chart-title").text(keys[i].chartHeader);
    
          if (currIndex == 12){
            showEndnotes();
          } else {  

              if (currentObject.chapter == self.state.previousChapter) {
                //what happens if you scroll down within a chapter!

                if (i >= self.state.currentIndex) {
                  if (currentChapter == 2) { //chapter two is different, because of Voronoi      
                    
                    revealLegend();

                    if (i == 6) {
                      chart.removeVoronoi(); //TODO: create method to remove Voronoi lines as well
                      chart.data(self.state.dataDictionary['house-calls'].data, i, currentChapter, currentName);
                      chart.animateAxes();
                    }

                    if (i == 7) {
                      chart.removeVoronoi();
                      chart.data(voronoiData[0], i, currentChapter, currentName);
                      chart.animateAxes();
                      chart.zoomVoronoi(voronoiData);
                    }

                    if (i == 8) {
                      console.warn(voronoiData);
                      chart.removeVoronoi();
                      chart.removeAnnotations();
                      chart.data(voronoiData[4], i, currentChapter, currentName);
                      chart.appendClipPath(voronoiData[4], "physician-satisfaction");
                      chart.appendLineGroup(voronoiData[4], "physician-satisfaction");
                      chart.revealCurtain("physician-satisfaction");

                      window.setTimeout(function() {
                        chart.zoomSingleVoronoi(voronoiData, "ehr");
                      },0);
                    
                    }

                    self.setState({ 
                      currentIndex: i,
                      previousChapter: currentObject.chapter
                    });

                  } else {

                    hideLegend();

                    chart.data(currentData, i, currentChapter, currentName);

                    /* FOR ARTISANAL PLACEMENT/ NUDGING OF GREENTIPS */
                    if (i == 4) {
                      chart.appendGreenTip(currentName, 35);
                    // } else if (i == 4) {
                    //   chart.appendGreenTip(currentName, -10);
                     } else if (i == 11) {
                      chart.appendGreenTip(currentName, 20);
                    } else {
                      chart.appendGreenTip(currentName);
                    }

                    if (i == 10) {
                      chart.resizeAndFadeOutLine("physician-growth");
                      chart.movePhysiciansGrowthGreenTip();
                    }
                    if (i == 11) {
                      chart.yDomain([0,20]);
                      chart.resizeAndFadeOutLine("physician-growth");
                      chart.yDomain([0,20]);
                      chart.resizeAndFadeOutLine("administrative-roles");
                      chart.yDomain([0,20]);
                    }

                    self.setState({ 
                      currentIndex: i,
                      previousChapter: currentObject.chapter
                    });                
                  }
                }

                if (i < self.state.currentIndex) {
                  //what happens if you scroll up within a chapter!

                  // d3.select(".foot").select("p:last-child").remove();
                  chart.removeAnnotations();

                  const iPlusOne = i+1;
                  if (currentChapter == 2) {
                    revealLegend();
                    //NOTE:
                    // This got to be kind of a mess, but check the .data() method 
                    // on chart object - it got all messed up, will prob want to refactor this,
                    // might be wise to rethink approach of work data() method. The chart object
                    // shouldn't really have stuff that show knowledge of implementation of the
                    // graphScroll. Trying to strike balance between overthough abstraction
                    // and expediency with how much of the behavior of this chart is basically nonsensical

                    if (i == 6) {
                      chart.updateWithNewData(voronoiData, 6, 2);
                      chart.drawAxes();
                      chart.zoomVoronoi(voronoiData, 1); //TODO: apparently need to do the fadeIn within the zoomVoronoi method for whatever reason.
                      chart.drawVoronoiPolygons(voronoiData);
                    }

                    if (i == 7) {
                      d3.select("#line-clip-path-physician-satisfaction").remove();
                      console.warn('you scroll up to section 7');
                      chart.updateWithNewData(voronoiData, 7, 2);
                      d3.select("#physician-satisfaction").select("g").select("path").transition().duration(500).style("stroke-opacity", 0);
                          window.setTimeout(function() { 
                            d3.select("#physician-satisfaction").remove(); 
                          }, 500);
                      chart.drawAxes();
                      chart.zoomVoronoi(voronoiData);
                      chart.fadeInLine("ehr");
                      chart.newData(voronoiData[0]);
                    }

                    if (i !== 6) {
                      chart.data(voronoiData, i, currentChapter, currentName);
                    }
                  } else {
                    hideLegend();

                    chart.removeLine(currentName);
                    chart.highlightLine(currentName);
                    chart.data(currentData, i, currentChapter, currentName);
                    chart.animateAxes();
                    chart.appendAnnotations();

                    if (i==9) {
                      chart.removeLastGreenTip(previousName, currentName);
                      chart.resizeAndFadeInLine("physician-growth");
                      chart.movePhysiciansGrowthGreenTip();
                    } else if (i==10) {
                      chart.removeLastGreenTip(previousName, currentName);
                      chart.resizeAndFadeInLine("physician-growth");
                      chart.resizeAndFadeInLine("administrative-roles");
                      // chart.movePhysiciansGrowthGreenTip();
                    } else {
                      chart.removeLastGreenTip(previousName, currentName);
                    }
                  }

                  self.setState({ 
                    currentIndex: i,
                    previousChapter: currentObject.chapter
                  });
                }

              } else {

                console.log(self.state.previousChapter);
                
                if (i >= self.state.currentIndex) {
                  //what happens in you scroll down to a new chapter!
                  const previousChapter = currentObject.chapter-1;

                  chart.removeClipPaths();
                  chart.removePreviousChapterLines(previousChapter);
                  chart.removeVoronoi(); //TODO: create method to remove Voronoi lines as well
                  chart.removeAllGreenTips();


                  if (currentChapter == 2) { //chapter two is different, because of Voronoi            
                    console.warn('current chapter is 2!!!');
                    revealLegend();
                    chart.removeClipPaths();
                    chart.data(voronoiData, i, currentChapter, currentName);

                    self.setState({ 
                      currentIndex: i,
                      previousChapter: currentObject.chapter
                    });

                  } else {
                    hideLegend();
                    console.warn('current chapter is other than 2!!!');
                    chart.data(currentData, i, currentChapter, currentName);
                    chart.appendGreenTip(currentName);

                    self.setState({ 
                      currentIndex: i,
                      previousChapter: currentObject.chapter
                    });
                  }
                }

                if (i < self.state.currentIndex) {
                  //what happens if you scroll up to a new chapter!
                  const previousChapter = currentChapter+1;

                  chart.removeAnnotations();

                  chart.removeClipPaths();
                  chart.removeChapterLines(previousChapter);
                  chart.removeVoronoi(); //TODO: create method to remove Voronoi lines as well
                  chart.removeAllGreenTips();


                  if (currentChapter == 2) { //scrolling up to voronoi section from section 3
                    revealLegend();

                    // chart.data(voronoiData, i, currentChapter, currentName);                
                    // chart.animateAxes();

                    if (i ==8) {
                      chart.updateWithNewData(voronoiData, 8, 2);
                      chart.drawAxes();
                      chart.drawVoronoi(voronoiData);
                      chart.removeVoronoi(); //TODO: there should be x-hover focus here, not the voronoi version.
                      chart.zoomVoronoi(voronoiData);
                      chart.appendClipPath(voronoiData[4], "physician-satisfaction");
                      chart.appendLineGroup(voronoiData[4], "physician-satisfaction");
                      chart.revealCurtain("physician-satisfaction");
                      chart.fadeLine("ehr");
                      chart.newData(voronoiData[4]);                 
                    }

                  } else {                

                    hideLegend();
                    chart.animateAxes();

                    keys.forEach(function(x, i) {
                     if (x.chapter == 1) {
                      if (i == 0) { //NOT SURE WHY THIS IS NECESSARY, BUT SEEMS TO WORK
                        chart.data(self.state.dataDictionary['house-calls'].data, 0, 1, 'house-calls');
                        chart.appendGreenTip('house-calls'); 
                      }
                      if (i <= 5) {
                        const dataName = x.data;
                        const d = self.state.dataDictionary[dataName];
                        chart.data(d.data, x.key, x.chapter, d.name);
                        chart.appendGreenTip(d.name);
                      }
                     }
                    });

                  }

              }

              self.setState({ 
                currentIndex: i,
                previousChapter: currentObject.chapter
              });
            }

          }

          if (currentObject.chapter == 1) {
            d3.select("#full-header").classed("purple-color", true).classed("blue-color", false).classed("green-color", false);
          } else if (currentObject.chapter == 2){
            d3.select("#full-header").classed("blue-color", true).classed("purple-color", false).classed("green-color", false);
          } else {
            d3.select("#full-header").classed("green-color", true).classed("blue-color", false).classed("purple-color", false);
          }

      });

(function() {

  window.addEventListener("resize", resizeThrottler, false);

  var resizeTimeout;
  function resizeThrottler() {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {
        resizeTimeout = null;
        actualResizeHandler();
     
       // The actualResizeHandler will execute at a rate of 15fps
       }, 66);
    }
  }
  actualResizeHandler();
}());

    // d3.select(window).on('resize.index', function(){
      function actualResizeHandler() {
          if (window.innerWidth < 768) {
              mobile = true;
          } else {
              mobile = false;
          }
          
          d3.select("#chart").classed("graph-scroll-below", false);

          console.warn("the index when you resized: " + currIndex);
          
          const cardVisible = d3.select("#card-container").node().children.length;

          if(cardVisible==0) {


            if (mobile == false) {
              chartWidth = getChartSize()[0]
              chartHeight = getChartSize()[1];
              d3.select('.foot').transition().duration(1000).style("opacity", 1).style("visibility", "visible").style("display", "block");
              d3.select('.foot-overlay').transition().duration(1000).style("opacity", 1).style("display", "block").style("visibility", "visible");
              d3.select('#full-header').style("opacity", 1).style("visibility", "visible").style("display", "block");
              d3.select('#mobile').style("opacity", 0);
              d3.select("defs").selectAll("clipPath").remove();
              // currIndex = 0;

              currIndex = 0;
              window.setTimeout(function() {
                window.scrollTo(0,0);
                gs.scrollTo(0);
                chart.resize(chartWidth,chartHeight);
                console.warn(self.state.dataDictionary['house-calls'].data, 0, 1, "house-calls")
                chart.data(self.state.dataDictionary['house-calls'].data, 0, 1, "house-calls");
                chart.appendGreenTip("house-calls");
              }, 0);

            } else if (mobile == true){
              d3.select('.foot').style("opacity", 0).style("visibility", "invisible").style("display", "none");
              d3.select('.foot-overlay').style("opacity", 0).style("visibility", "invisible").style("display", "none");
              d3.select('#full-header').style("opacity", 0).style("visibility", "invisible").style("display", "none");

              window.setTimeout(function() {
                d3.select('.foot').style("opacity", 0).style("visibility", "invisible").style("display", "none");
                d3.select('.foot-overlay').style("opacity", 0).style("visibility", "invisible").style("display", "none");
                d3.select('#full-header').style("opacity", 0).style("visibility", "invisible").style("display", "none");
                d3.select('#mobile').style("opacity", 1);
              }, 0);
            }
            
          
            // self.setState({ 
            //       currentIndex: currIndex
            // });
          } else if(cardVisible==1) {
            //do nothing
            currIndex = 0;
            // d3.select("#header-text").text(keys[0].chapterHeader);
            // d3.select("#chart-title").text(keys[0].chartHeader);
            // textCrawl.move(0);
            // textCrawl.data(1, 0);
            // progress.el.style("width", progress.scale(0)+"%").style("background-color", purple);          
            // d3.select("#chart").classed("graph-scroll-below", false);
            // window.setTimeout(function() {
            //     d3.select("#chart").classed("graph-scroll-below", false);
            //     d3.select(".graph-scroll-active").classed("graph-scroll-active", false);
            //     d3.select("#sections").select("div").classed("graph-scroll-active", true);
            //     window.scrollTo(0,0);
            //     gs.scrollTo(0);
            //     chart.resize(chartWidth,chartHeight);
            // }, 0);
          }

};

    d3.select('.moveDown').on('click',function() {
      d3.select("#chart").classed("graph-scroll-below", false);
      console.warn("moveDown")
      if (currIndex !== 12) {
        gs.scrollTo(currIndex+1);
      } else if (currIndex == 12) {
        showEndnotes();
      }
    });

    d3.select('.moveUp').on('click',function() {
      d3.select("#chart").classed("graph-scroll-below", false);
      console.warn("moveUp")
      if (currIndex !== 0) {
        gs.scrollTo(currIndex-1);
      } else {
        window.scrollTo(0,0);
      }
    })

  }

  render() {
    const spacer = {
      height: 900+"px",
      background: "orange",
      opacity: 0.5
    };
    const button = {
      zIndex: 1000000000000000,
      height: "100px",
      width: "100px",
      backgroundColor: "red",
      position: "absolute",
      bottom: "70px",
      left: "80px",
      pointer: "cursor"
    };
    const arrow = {
      opacity: 0
    };
    const darkPurple = "#3E1052";
    return (
      <div>
        <div id='full-header-space'></div>

        <div id="full-header" className="sticky-header stuck">
          <div id="bg-progress"></div>
          <div id="header-text" className="mark-bold"></div>
          <div id="chart-title" className="mark black-text"></div>
          <div id="progress-container">
            
              <div className="legend-container">

                <div className="legend">

                  <div className="legend-span">
                    <svg className="legend-svg" height="20" width="20" id="house-phones" data-name="Layer 1" viewBox="0 -5 25.21 13.13"><title >line-legend</title><path d="M1.39,13.56a1,1,0,0,1-.71-1.71L9.9,2.65l6,6,8-8a1,1,0,1,1,1.41,1.41l-9.37,9.37-6-6-7.8,7.8A1,1,0,0,1,1.39,13.56Z" transform="translate(-0.39 -0.44)" fill="#FFCF03" ></path>
                    </svg>
                    <div className="legend-text">&nbsp;% of Households w/ Phone Nearby</div>
                  </div>

                  <div className="legend-span">
                    <svg className="legend-svg" height="20" width="20" id="house-computers" data-name="Layer 1" viewBox="0 -5 25.21 13.13"><title>line-legend</title><path d="M1.39,13.56a1,1,0,0,1-.71-1.71L9.9,2.65l6,6,8-8a1,1,0,1,1,1.41,1.41l-9.37,9.37-6-6-7.8,7.8A1,1,0,0,1,1.39,13.56Z" transform="translate(-0.39 -0.44)" fill="#F28C08"></path>
                    </svg>
                    <div className="legend-text">&nbsp;% of Households w/ Computers</div>
                  </div>
                </div>

                <div className="legend">

                  <div className="legend-span">
                    <svg className="legend-svg" height="20" width="20" id="net-use" data-name="Layer 1" viewBox="0 -5 25.21 13.13"><title>line-legend</title><path d="M1.39,13.56a1,1,0,0,1-.71-1.71L9.9,2.65l6,6,8-8a1,1,0,1,1,1.41,1.41l-9.37,9.37-6-6-7.8,7.8A1,1,0,0,1,1.39,13.56Z" transform="translate(-0.39 -0.44)" fill="#863375"></path>
                    </svg>
                    <div className="legend-text">&nbsp;% of Population Using Internet</div>
                  </div>

                  <div className="legend-span">
                    <svg className="legend-svg" height="20" width="20" id="ehr-squiggle" data-name="Layer 1" viewBox="0 -5 25.21 13.13" ><title>line-legend</title><path d="M1.39,13.56a1,1,0,0,1-.71-1.71L9.9,2.65l6,6,8-8a1,1,0,1,1,1.41,1.41l-9.37,9.37-6-6-7.8,7.8A1,1,0,0,1,1.39,13.56Z" transform="translate(-0.39 -0.44)" fill="#0F4B91"></path>
                    </svg>
                    <div className="legend-text">&nbsp;Electronic Health Records</div>
                  </div>

                  <div className="legend-span opacity-one">
                    <svg className="legend-svg" height="20" width="20" id="physician-squiggle" data-name="Layer 1" viewBox="0 -5 25.21 13.13"><title>line-legend</title><path d="M1.39,13.56a1,1,0,0,1-.71-1.71L9.9,2.65l6,6,8-8a1,1,0,1,1,1.41,1.41l-9.37,9.37-6-6-7.8,7.8A1,1,0,0,1,1.39,13.56Z" transform="translate(-0.39 -0.44)" fill="#B9C932"></path>
                    </svg>
                    <div className="legend-text">&nbsp;Physician Satisfaction</div>
                  </div>
                </div>

              </div>
          </div>
        </div>

        <div className="clearboth"></div>

    <div id="card-container">
        <div id="headline-card">
          <div className="card__bg__image">
            <img id="card" src="images/hero.jpg"/>
            <div id="cover-header">
              <h1> 
                <span>The</span><br />
                <span>Evolution</span><br />
                <span>of Medical</span><br />
                <span>Practice</span><br />
              </h1>
              <h2>1890 to Today</h2>
            </div>
            <div id="down-button" onClick={this.instantiateChart}>
              <img src="images/click-proceed.png" id="click-proceed"/>
              <img src="images/swoopy-line.png" id="swoopy-line"/>
              <svg id="down-button-svg-container" viewBox="0 0 78 43">
                <path d="M39,43L0.88,5.09A3,3,0,0,1,.88.87a3,3,0,0,1,4.24,0L39,34.56,72.88,0.87a3,3,0,0,1,4.24,0,3,3,0,0,1,0,4.22Z" transform="translate(0)" fill="#f1f2f2">
                </path>
              </svg>
            </div>
          </div>
        </div>
    </div> {/* #card-container */}
       
        <div id="inner-content">
          
          <div className="foot" id="foot">
          </div>
          <div className="foot-overlay"></div>

          <div id='graphic'>
            <div id='sections'>
            </div>

            <div id='chart'>
              <div className='chart-container'>
              </div>
            </div>

            <div className="carousel-arrow left moveUp">
              <svg width="80px" height="80px" viewBox="-8 -5 100 100">
                {/*<polyline style={arrow} fill="none" stroke="purple" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" points="45.63,75.8 0.375,38.087 45.63,0.375 "/>*/}
                <polyline style={arrow}
                  fill="none"
                  stroke={darkPurple}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round" 
                  points="50,25 20,50 50,75"
                />
                <circle cx="39" cy="49" r="40" fill="none" stroke={darkPurple} strokeWidth="2" style={arrow}>
                </circle>
              </svg>
            </div>
            <div className="carousel-arrow right moveDown" >
              <svg width="80px" height="80px" viewBox="-8 -5 100 100">
                  {/*<polyline style={arrow} fill="none" stroke={darkPurple} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" points="0.375,0.375 45.63,38.087 0.375,75.8 "/>*/}
                  <polyline style={arrow} fill="none" 
                    stroke={darkPurple} 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    points="30,25 60,50 30,75"
                  />
                  <circle cx="38" cy="49" r="40" fill="none" stroke={darkPurple} strokeWidth="2" style={arrow}>
                  </circle>
              </svg>
            </div>

          </div>{/* '#graphic' */}

          <div id="mobile"></div>

          <div className="clearboth"></div>

          </div>

          <div className="method">

        </div>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/